import React from 'react';
import './About.css'
import aboutImg from '../../images/my-bg1.jpg'
import av from '../../images/avataaars1.png'

const About = () => {
    
    return (
       <div id='about' className='row p-5' style={{backgroundColor:'#1f2833'}}>
           <h1 style={{color:'white', marginBottom:'50px'}}>About me</h1>
           <div data-aos="fade-right" data-aos-duration="3050" className='col-md-7 col-sm-12' style={{padding:'80px',color:'#cc6666'}}>
               <p>Hi, I’m Faraz and I’m a passionate frontend web developer. I write clean and efficient javascript code.
                I have extensive knowledge of Javascript, React js, Html, CSS. I love communicating with new people and solving coding challenges.
                </p>

           </div>
           <div data-aos="fade-left" data-aos-duration="3100" className='col-md-5 col-sm-12' style={{border:'2px solid rgb(30, 30, 40)', backgroundColor:'rgb(30, 30, 40)', boxShadow:'5px 10px', width:'400px'}}>
               <img className='w-75 px-auto mx-auto' src={av} alt='' style={{width:'100px'}}></img>
              
          

           </div>
       </div>
    );
};

export default About;